module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_1-cde6cbb63ca516e4939a9d9395c11ced.jpg";